import React, { useState , useEffect} from "react"
import { Link, navigate } from "gatsby"
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import CookieConsent from "react-cookie-consent";
import PropTypes from "prop-types"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import NavContactBgImage from '../images/nav_contact_bg_image.png'

import authClient from "../auth"
import Header from './header'

import { faSignOutAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn, faPinterest, faYoutube } from '@fortawesome/free-brands-svg-icons'


import ForwardDotted from  '../images/forward_dotted.svg'
import FireWork1 from '../images/firework/1.gif'
import FireWork2 from '../images/firework/2.gif'
import FireWork3 from '../images/firework/3.gif'
import FireWork4 from '../images/firework/4.gif'
import FireWork5 from '../images/firework/5.gif'

//Import Lazy Loading Component
import Loadable from '@loadable/component'

import "./layout.scss"
import '../styles/icons.scss'
import Styles from "./desktop-left-navigation.module.scss"

const CallBackModal = Loadable(() => import('../components/CallBackModal/ValentineModal'))

const isBrowser = () => typeof window !== "undefined"
const UserName = isBrowser() ? (localStorage.getItem('student_first_name') ? localStorage.getItem('student_first_name') : 'Guest') :  'Guest'
const localSt_license = isBrowser() ? (localStorage.getItem('license_title') ? localStorage.getItem('license_title') : 'Basic') :  ''
const user_avatar = isBrowser() ? (localStorage.getItem('user_avatar') ? localStorage.getItem('user_avatar') : '') :  ''
const localSt_license_validity = isBrowser() ? (localStorage.getItem('license_validity') ? localStorage.getItem('license_validity') : '') :  ''
const DefaultHeader = isBrowser() ? { "authorization": "Token " + localStorage.getItem('student_authenticity_token') } : {}
// const teacherAnim = 'https://assets5.lottiefiles.com/packages/lf20_m5noxovo.json'
function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min) ) + min
}

const FireworkComponent = (props) => {

  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min
  }
  let array = [FireWork1,FireWork2,FireWork3,FireWork4,FireWork5]
  if(props.time === 0) return null
  return (
    <img src={array[Math.floor(Math.random() * array.length)]} style={{position:'absolute', left:`${getRndInteger(0, 100)}%`, top:`${getRndInteger(0, 100)}%`, pointerEvents:'none'}} alt="This is an animated gif image, but it does not move"/>
  )
}

const Layout = ({ children }) => {

  const [activeKey, setActiveKey] = useState('')
  const [activeButton, setActiveButton] = useState('')
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [sidebarClass, setSidebarClass] = useState('sidebar open')
  const [userLoggedIn, setUserLoggedIn] =useState(false)
  const [brand_icon_display, setBrandIconDisplay] = useState(true)
  const [basic_user_detail, setBasicUserDetail] = useState(undefined)
  const [basic_user_detail_fetched, setBasicUserDetailFetched] = useState(false)
  const [timeLeft, setTimeLeft] = useState(15);

  // useEffect(() => {
  //   setTimeout(function(){
  //     if (authClient.isAuthenticated() && !basic_user_detail_fetched) {
  //       fetchBasicUserDetail()
  //     }
  //   }, 3000)
  // },[])

  useEffect(() => {
    setTimeout(function(){
      setTimeLeft(0)
    },30000)
  }, []);

  useEffect(() => {
    if (isBrowser()) {
      let value = localStorage.getItem('student_authenticity_token')
      if (value && value !== undefined && value !== 'undefined' && value !== null && value.length > 5 && value != '') {
        setUserLoggedIn(true)
      } else {
        setUserLoggedIn(false)
      }
    }
  }, [isBrowser() ? localStorage.getItem('student_authenticity_token') : ''])

  useEffect(() => {
    var pages_array = ['my-trainings,videos,lptv,blogs,events,my-quizzes,resources,web-recordings,my-speak-series,prime-content,book-mentor','classroom,onlinecourses,onlinecrashcourses,eLearning,quizzes,openassessment','our-team, leanpitch-reviews, why-us, ourtrainers, our-presence, cities, about-us, about,update-profile']
    let page_uri = isBrowser() ? '/'+window.location.pathname.substr(1) :  'false'
    let page_location = isBrowser() ? window.location :  'false'
    // if (page_uri.split("/")[1] === 'onlinecrashcourses') {
    //   setActiveButton( 'onlinecourses' )
    //   setActiveKey('1')
    // }
    if (page_location.hash.split("/")[0] === "#all-trainings") {
      setActiveButton('')
      setActiveKey('1')
    }else if (page_uri.replace(/\//g, "") === "") {
      if (authClient.isAuthenticated()){
        setActiveKey('0')
      }else{
        setActiveKey('1')
      }
      setActiveButton('')
      // setActiveKey(authClient.isAuthenticated() ? '0' : '1')
    }else if (page_uri.replace(/\//g, "") === 'dashboard') {
      setActiveButton('')
      setActiveKey('0')
    }else {
      for (var i = 0; i <= pages_array.length - 1; i++) {
        if ( pages_array[i].includes( page_uri.split("/")[1] ) ) {
          setActiveKey(i.toString())
          setActiveButton( page_uri.split("/")[1] )
          if (page_uri.split("/")[1] === 'cities') {
            setActiveButton( 'our-presence' )
          } else if (page_uri.split("/")[1] === 'trainer' || page_uri.split("/")[1] === 'ourtrainers') {
            setActiveButton( 'ourtrainers' )
          } else if (page_uri.split("/")[1] === 'about' || page_uri.split("/")[1] === 'about-us') {
            setActiveButton( 'our-team' )
          } else if (page_uri.split("/")[1] === 'openassessment') {
            setActiveButton( 'quizzes' )
          }else if (page_uri.split("/")[1] === 'lptv') {
            setActiveButton( 'videos' )
          }else if (page_uri.split("/")[1] === 'update-profile') {
            setActiveKey('')
          }
        }
      }
    }
  },[isBrowser() ? window.location : ''])

  async function fetchBasicUserDetail() {
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/students/basic/detail/`, {headers: DefaultHeader}).then(response => response.json()).then(data => {
      if (data['detail'] === "Invalid token.") {
        authClient.signOut();
        localStorage.removeItem('student_authenticity_token');
        localStorage.removeItem('username');localStorage.removeItem('user_avatar')
        window.location.reload(true);
      } else {
        if (Array.isArray(data)) {
          setBasicUserDetail(data[0]);setBasicUserDetailFetched(true)
          localStorage.setItem('student_first_name', data[0].first_name);localStorage.setItem('license_title', data[0].license_title);
          localStorage.setItem('license_validity', data[0].license_validity);localStorage.setItem('user_avatar', data[0].avatar)
        } else {
          setBasicUserDetail(data);setBasicUserDetailFetched(true)
          localStorage.setItem('student_first_name', data.first_name);localStorage.setItem('license_title', data.license_title);
          localStorage.setItem('license_validity', data.license_validity);localStorage.setItem('user_avatar', data.avatar)
        }
      }
    }).catch(error => {
      setBasicUserDetail([]);setBasicUserDetailFetched(false)
      let error_messages = ''
      if (error.response) {
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
      }
      if(error_messages === 'Invalid token.<br>'){authClient.signOut();
        localStorage.removeItem('student_authenticity_token');
          localStorage.removeItem('username');localStorage.removeItem('user_avatar')
        window.location.reload(true);
      }
    })
  }
  //this function is hover effect onMouseOut
  function onMouseOut(e,id,remove_class,add_class,active_button) {
    e.preventDefault();
    if (activeButton !== active_button) {
      document.getElementById(id).classList.remove(remove_class);
      document.getElementById(id).classList.add(add_class);
    }
  }
  //this function is hover effect onMouseOver
  function onMouseOver(e,id,add_class,remove_class,active_button) {
    e.preventDefault();
    if (activeButton !== active_button) {
      document.getElementById(id).classList.remove(remove_class);
      document.getElementById(id).classList.add(add_class);
    }
  }

  function showPrimeContentLink() {
    if (localSt_license !== 'Basic') {
      return(
        <Link className={` ${activeButton.includes('prime-content') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/prime-content" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('prime-content');}}
          onFocus={ () => void 0 }
          onBlur={ () => void 0 } >
          <div className="d-flex font-w500" >
            <div className={`d-flex`}><span id={'prime_content'} style={{marginLeft: '-5px'}} className={`sprite_image_4 ${localSt_license === 'Prime' ? `${Styles.nav_prime_icon}` : `${Styles.nav_value_icon}`} mr-1`}></span></div>My {localSt_license} Content
          </div>
        </Link>
      )
    } else {
      return null
    }
  }
  function showMentorLink() {
    // if (authClient.isAuthenticated()) {
      return(
        <Link className={` ${activeButton.includes('book-mentor') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/book-mentor/" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('book-mentor');}}
          onMouseOver={(e) => {onMouseOver(e,'book_mentor',`${Styles.events_blue_icon}`,`${Styles.events_black_icon}`,'book-mentor')}}
          onMouseOut={(e) => {onMouseOut(e,'book_mentor',`${Styles.events_blue_icon}`,`${Styles.events_black_icon}`,'book-mentor')}}
          onFocus={ () => void 0 }
          onBlur={ () => void 0 } >
          <div className="d-flex font-w500" >
            <div className={`d-flex`}><span id={'book_mentor'} className={`sprite_image_small_2 ${activeButton.includes('book-mentor') ? `${Styles.events_blue_icon}` : `${Styles.events_black_icon}`} mr-2 my-auto`}></span></div>Talk to a Mentor
          </div>
        </Link>
      )
      return null
    // } else {
    //   return null
    // }
  }

  function LoginBtn() {
    let page_uri = isBrowser() ? '/'+window.location.pathname.substr(1) :  'false'
    if (page_uri === '/logout' ||  page_uri==="logout" || page_uri === "logout/"
        || page_uri === "/logout/"){
      page_uri = '/'
    }
    if (authClient.isAuthenticated()) {
      let license_title = basic_user_detail_fetched ? basic_user_detail.license_title : localSt_license
      if (license_title !== 'Prime' || (localSt_license === 'Prime' && localSt_license_validity === 'month')) {
        return (
          <Button variant="outline-primary" size="sm" className={`${Styles.button_class_new}`}
            style={{borderRadius: '20px', padding: '3px 3px', marginTop: '3px', color: `#29abe2`, borderColor: `#29abe2`}} >
            <Link to="/licenses" className={`m-0 ${Styles.login_btn_link}`} style={{padding: '1px 10px', textDecoration: 'none', color: `rgb(41, 171, 226)`}}>Upgrade your plan</Link>
          </Button>
        );
      } else {
        return null;
      }
    } else {
      return (
        <Button variant="outline-primary" size="sm" className={`${Styles.login_btn_hover_transition}`}
          style={{borderRadius: '20px', padding: '1px 10px', width: '80px', marginTop: '3px', borderColor: `rgb(41, 171, 226)`}} >
          <Link to={`/login?redirection_url=${page_uri}`} className={`${Styles.login_btn_link}`} style={{textDecoration: 'none', color: `rgb(41, 171, 226)`}} id="login">Login</Link>
        </Button>
      );
    }
  }

  function showSignout() {
    if (userLoggedIn) {
      return (
        <Link activeClassName={'bg-theme-blue'} className={`bg-faded-link float-left w-100`}  to="/logout" >
          <Col className={`pb-2 pl-4`}>
            <Accordion.Toggle as={Card.Header} eventKey="3" className={` ${Styles.border_bg_none} pb-2 px-0`} >
              <div className="d-flex font-w500" >
                <FontAwesomeIcon className='mr-2 my-auto' icon={faSignOutAlt} size="1x">Logout</FontAwesomeIcon>
                Logout
                <div className={`d-flex`}><span className={`sprite_image_2 ml-2 my-auto`}></span></div>
              </div>
            </Accordion.Toggle>
          </Col>
        </Link>
      );
    } else {
      return (
        ''
      );
    }
  }
  const brandIconUrl = (brand, type) => {
    let brand_url = [{"brand": 'facebook', "name": '@Leanpitch', "url": 'https://www.facebook.com/Leanpitch/', 'icon': faFacebookF},
    {"brand": 'linkedin', "name": '/Leanpitch', "url": 'https://www.linkedin.com/company/leanpitch/', 'icon': faLinkedinIn},
    {"brand": 'instagram', "name": '/Leanpitch', "url": 'https://www.instagram.com/leanpitchtechnologies/', 'icon': faInstagram},
    {"brand": 'twitter', "name": '@Leanpitch', "url": 'https://twitter.com/leanpitch', 'icon': faTwitter},
    {"brand": 'pinterest', "name": '@Leanpitch', "url": 'https://in.pinterest.com/leanpitch/', 'icon': faPinterest},
    {"brand": 'youtube', "name": '/Leanpitch', "url": 'https://www.youtube.com/channel/UCey8O_fB117PnkFuyLlffcA', 'icon': faYoutube}]
    let resulted_data
    let index = brand_url.findIndex(item => item.brand === brand)
    if (type === 'name') {
      resulted_data = brand_url[index].name
    }else if (type === 'url') {
      resulted_data = brand_url[index].url
    }else {
      resulted_data = brand_url[index].icon
    }
    return resulted_data;
  }
  const displayBrandIcon = type => {
    let brand_icon = ['facebook', 'twitter', 'instagram', 'linkedin', 'pinterest', 'youtube']
    if (type === 'collapse') {
      return (
        brand_icon.map((icon, index) => {
          return (
            <FontAwesomeIcon key={index} icon={brandIconUrl(icon, 'icon')} className="text-white" style={{margin: `auto 3px`, width: '1rem'}} />
          );
        })
      );
    }else {
      return (
        <div className={`${Styles.layout_brand} pt-3 pb-2`} style={{width: '240px'}}>
          {brand_icon.map((brand, index) => {
            return (
              <Col key={index} sm="12" md="12" lg="12" className="float-left d-inline-flex px-0 align-items-center py-1">
                <Col sm="1" md="1" lg="1" className="float-left pr-0 pl-1">
                  <a href={brandIconUrl(brand, 'url')} target="_blank" rel="noopener noreferrer" className="pointer"><FontAwesomeIcon icon={brandIconUrl(brand, 'icon')} className="text-white" style={{margin: `auto 3px`, width: '1rem'}} /></a>
                </Col>
                <Col sm="7" md="7" lg="7" xl="6" className="float-left pr-0">
                  <p className="text-white" style={{fontSize: '1.1vw'}}>{brandIconUrl(brand, 'name')}</p>
                </Col>
                <Col sm="4" md="4" lg="4" xl="5" className="float-left text-right pl-0">
                  <a href={brandIconUrl(brand, 'url')} target="_blank" rel="noopener noreferrer" className={`${Styles.button_class_new} text-white pointer`} style={{borderRadius: '20px', padding: '3px 12px', borderColor: `rgb(255, 255, 255)`, fontSize: '0.9vw', backgroundColor: 'rgb(255, 255, 255, 34%)'}}>Follow </a>
                </Col>
              </Col>
            );
          })}
        </div>
      );
    }
  }
  const followBrandIcon = e => {
    e.preventDefault();
    setBrandIconDisplay(!brand_icon_display)
  }
  const defaultProfilePic = () => {
    return (
      <div onClick={()=>navigate(authClient.isAuthenticated() ? '/update-profile' : '/licenses')} className="astronaut float-left" style={{marginRight: '10px'}}>
      </div>
    );
  }
  const profilePicAfterLogin = () => {
    return (
      <LazyLoadImage src={user_avatar} alt={basic_user_detail_fetched ? basic_user_detail.first_name.toLowerCase() : UserName.toLowerCase()} className="float-left" style={{width: '60px', height: '60px', marginRight: '10px'}} onClick={()=>navigate(authClient.isAuthenticated() ? '/update-profile' : '/licenses')}/>
    )
  }
  const displayProfilePic = () => {
    if (authClient.isAuthenticated()) {
      if (basic_user_detail_fetched) {
        if (basic_user_detail && basic_user_detail.avatar && basic_user_detail.avatar.length > 37) {
          return profilePicAfterLogin()
        } else {
          return defaultProfilePic();
        }
      } else {
        if (user_avatar && user_avatar.length > 37) {
          return profilePicAfterLogin();
        } else {
          return defaultProfilePic();
        }
      }
    } else {
      return defaultProfilePic();
    }
  }
  const displayUsername = () => {
    if (authClient.isAuthenticated()) {
      if (basic_user_detail_fetched) {
        if (basic_user_detail && basic_user_detail.first_name) {
          return `Hello ${basic_user_detail.first_name}`;
        } else {
          return `Hello ${UserName}`;
        }
      } else {
        return `Hello ${UserName}`;
      }
    } else {
      return 'Hello Guest';
    }
  }
  const displayLicenseTitle = () => {
    if (userLoggedIn) {
      if (basic_user_detail_fetched) {
        if (basic_user_detail && basic_user_detail.license_title) {
          return basic_user_detail.license_title;
        } else {
          return localSt_license;
        }
      } else {
        return localSt_license;
      }
    } else {
      return 'Basic';
    }
  }

  const displaySidebar = () => {
    if (sidebarOpen) {
      let background_image = <LazyLoadImage src={NavContactBgImage} alt={`nav_contact_bg_image`}/>
      return (
        <div className={`px-0 ${sidebarClass} unselectable`}>
          <Col xs="12" sm="12" md="12" lg="12" className={`py-0 px-0 ${Styles.desktop_left_nav_main}`} style={{ width: `240px`, maxWidth: `240px`, minWidth: `240px`}}>
            <Col xs="12" sm="12" md="12" lg="12" className={`px-2 pt-3 pb-0 d-flex ${activeKey === '0' ? 'bg-white' : Styles.border_bg_none}`} style={{ zIndex: 2 }}>
              <Col xs="12" sm="12" md="12" lg="12" className="pr-0 pointer">
                {displayProfilePic()}
                <h6 onClick={()=>navigate(authClient.isAuthenticated() ? '/update-profile' : '/licenses')} className="my-1" >{displayUsername()}</h6>
                <p className={`m-0`} style={{fontSize: `.8rem`}} onClick={() => navigate('/licenses')}>Your Plan is <span className="pointer" style={{color: 'rgb(41, 171, 226)', fontWeight: `bold`}} >{displayLicenseTitle()}</span></p>
                {LoginBtn()}
              </Col>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" className={`px-0`} style={{position: 'relative'}}>
              <Accordion activeKey={activeKey}>
                <Card className={`${Styles.border_bg_none} ${activeKey === '0' ? 'bg-white' : Styles.border_bg_none}`}>
                  <Link to="/dashboard" >
                    <Accordion.Toggle as={Card.Header} eventKey="0" className={`pointer ${Styles.border_bg_none} pl-4`} onClick={ () => {setActiveKey(activeKey === '0' ? '' : '0');setActiveButton('');}} >
                      <div className={`${activeKey === '0' ? Styles.left_nav_link_header_active : Styles.left_nav_link_header} d-inline-flex`} >
                        <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '0' ? `${Styles.dashboard_icon_white}` : `${Styles.dashboard_icon_black}`} mr-2 my-auto`}></span></div>
                        My Dashboard
                        <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '0' ? 'down_white_arrow' : `down_black_arrow rotate-right`} ml-2 my-auto`}></span></div>
                      </div>
                    </Accordion.Toggle>
                  </Link>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body className={`d-grid ${Styles.border_bg_none} py-2 pr-0 pl-2 ml-3`} >
                      <Link className={` ${activeButton.includes('my-trainings') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-trainings" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('my-trainings');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_trainings',`${Styles.training_icon_blue}`,`${Styles.training_icon_black}`,'my-trainings')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_trainings',`${Styles.training_icon_blue}`,`${Styles.training_icon_black}`,'my-trainings')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_trainings'} className={`sprite_image_small_2 ${activeButton.includes('my-trainings') ? `${Styles.training_icon_blue}` : `${Styles.training_icon_black}`} mr-2 my-auto`}></span></div>My Trainings
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('videos') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/videos" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('videos');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_videos',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'videos')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_videos',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'videos')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_videos'} className={`sprite_image_small_2 ${activeButton.includes('videos') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>My Videos
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('blogs') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/blogs" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('blogs');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_blog',`${Styles.blog_blue_icon}`,`${Styles.blog_black_icon}`,'blogs')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_blog',`${Styles.blog_blue_icon}`,`${Styles.blog_black_icon}`,'blogs')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_blog'} className={`sprite_image_small_2 ${activeButton.includes('blogs') ? `${Styles.blog_blue_icon}` : `${Styles.blog_black_icon}`} mr-2 my-auto`}></span></div>My Blogs
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('events') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/events" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('events');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_events',`${Styles.events_blue_icon}`,`${Styles.events_black_icon}`,'events')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_events',`${Styles.events_blue_icon}`,`${Styles.events_black_icon}`,'events')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_events'} className={`sprite_image_small_2 ${activeButton.includes('events') ? `${Styles.events_blue_icon}` : `${Styles.events_black_icon}`} mr-2 my-auto`}></span></div>My Events
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('my-quizzes') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-quizzes" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('my-quizzes');}}
                        onMouseOver={(e) => {onMouseOver(e,'my-quizzes',`${Styles.quiz_blue_icon}`,`${Styles.quiz_black_icon}`,'my-quizzes')}}
                        onMouseOut={(e) => {onMouseOut(e,'my-quizzes',`${Styles.quiz_blue_icon}`,`${Styles.quiz_black_icon}`,'my-quizzes')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my-quizzes'} className={`sprite_image_small_2 ${activeButton.includes('my-quizzes') ? `${Styles.quiz_blue_icon}` : `${Styles.quiz_black_icon}`} mr-2 my-auto`}></span></div>My Quizzes
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('resources') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/resources" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('resources');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_resources',`${Styles.resources_blue_icon}`,`${Styles.resources_black_icon}`,'resources')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_resources',`${Styles.resources_blue_icon}`,`${Styles.resources_black_icon}`,'resources')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_resources'} className={`sprite_image_small_2 ${activeButton.includes('resources') ? `${Styles.resources_blue_icon}` : `${Styles.resources_black_icon}`} mr-2 my-auto`}></span></div>My Resources
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('web-recordings') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/web-recordings" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('web-recordings');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_podcast',`${Styles.record_blue_icon}`,`${Styles.record_black_icon}`,'web-recordings')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_podcast',`${Styles.record_blue_icon}`,`${Styles.record_black_icon}`,'web-recordings')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_podcast'} className={`sprite_image_small_2 ${activeButton.includes('web-recordings') ? `${Styles.record_blue_icon}` : `${Styles.record_black_icon}`} mr-2 my-auto`}></span></div>Webinar Recordings
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('my-speak-series') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/my-speak-series" activeClassName={`${Styles.left_nav_link_active}`}  onClick={ () => {setActiveButton('my-speak-series');}}
                        onMouseOver={(e) => {onMouseOver(e,'my_series',`${Styles.expert_blue_icon}`,`${Styles.expert_black_icon}`,'my-speak-series')}}
                        onMouseOut={(e) => {onMouseOut(e,'my_series',`${Styles.expert_blue_icon}`,`${Styles.expert_black_icon}`,'my-speak-series')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'my_series'} className={`sprite_image_small_2 ${activeButton.includes('my-speak-series') ? `${Styles.expert_blue_icon}` : `${Styles.expert_black_icon}`} mr-2 my-auto`}></span></div>Expert Speak Series
                        </div>
                      </Link>
                      {showPrimeContentLink()}
                      {showMentorLink()}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card className={` ${activeKey === '1' ? 'bg-white' : Styles.card_border}`} style={{borderTop: '1px solid #ebe8e8'}}>
                  <Link to="/#all-trainings" >
                    <Accordion.Toggle as={Card.Header} eventKey="1" className={`pointer ${Styles.border_bg_none} pl-4`} onClick={ () => {setActiveKey(activeKey === '1' ? '' : '1');}} >
                      <div className={`${activeKey === '1' ? Styles.left_nav_link_header_active : Styles.left_nav_link_header} d-inline-flex`} >
                        <div className={`d-flex`}><span className={`${activeKey === '1' ? `sprite_image_3 ${Styles.training_icon_white}` : `sprite_image_2 ${Styles.training_icon_large_black}`} mr-2 my-auto`}></span></div>
                        All Trainings
                        <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '1' ? 'down_white_arrow' : 'down_black_arrow rotate-right'} ml-2 my-auto`}></span></div>
                      </div>
                    </Accordion.Toggle>
                  </Link>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body className={`d-grid ${Styles.border_bg_none} py-2 pr-0 pl-2 ml-3`} >
                      {/* <Link className={` ${activeButton.includes('classroom') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/classroom" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('classroom');}}
                        onMouseOver={(e) => {onMouseOver(e,'classroom',`${Styles.classroom_training_icon_blue}`,`${Styles.classroom_training_icon_black}`,'classroom')}}
                        onMouseOut={(e) => {onMouseOut(e,'classroom',`${Styles.classroom_training_icon_blue}`,`${Styles.classroom_training_icon_black}`,'classroom')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'classroom'} className={`sprite_image_small_2 ${activeButton.includes('classroom') ? `${Styles.classroom_training_icon_blue}` : `${Styles.classroom_training_icon_black}`} mr-2 my-auto`}></span></div>Classroom
                        </div>
                      </Link> */}
                      <Link className={` ${activeButton.includes('onlinecrashcourses') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/onlinecrashcourses" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('onlinecrashcourses');}}
                        onMouseOver={(e) => {onMouseOver(e,'onlinecrashcourses',`${Styles.online_training_icon_blue}`,`${Styles.online_training_icon_black}`,'onlinecrashcourses')}}
                        onMouseOut={(e) => {onMouseOut(e,'onlinecrashcourses',`${Styles.online_training_icon_blue}`,`${Styles.online_training_icon_black}`,'onlinecrashcourses')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'onlinecrashcourses'} className={`sprite_image_small_2 ${activeButton.includes('onlinecrashcourses') ? `${Styles.online_training_icon_blue}` : `${Styles.online_training_icon_black}`} mr-2 my-auto`}></span></div>Crash Courses
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('onlinecourses') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/onlinecourses" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('onlinecourses');}}
                        onMouseOver={(e) => {onMouseOver(e,'online',`${Styles.online_training_icon_blue}`,`${Styles.online_training_icon_black}`,'onlinecourses')}}
                        onMouseOut={(e) => {onMouseOut(e,'online',`${Styles.online_training_icon_blue}`,`${Styles.online_training_icon_black}`,'onlinecourses')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'online'} className={`sprite_image_small_2 ${activeButton.includes('onlinecourses') ? `${Styles.online_training_icon_blue}` : `${Styles.online_training_icon_black}`} mr-2 my-auto`}></span></div>Certification Courses
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('eLearning') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/eLearning" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('eLearning');}}
                        onMouseOver={(e) => {onMouseOver(e,'elearning',`${Styles.e_learning_training_icon_blue}`,`${Styles.e_learning_training_icon_black}`,'eLearning')}}
                        onMouseOut={(e) => {onMouseOut(e,'elearning',`${Styles.e_learning_training_icon_blue}`,`${Styles.e_learning_training_icon_black}`,'eLearning')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'elearning'} className={`sprite_image_small_2 ${activeButton.includes('eLearning') ? `${Styles.e_learning_training_icon_blue}` : `${Styles.e_learning_training_icon_black}`} mr-2 my-auto`}></span></div>E learning
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('quizzes') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/quizzes" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('quizzes');}}
                        onMouseOver={(e) => {onMouseOver(e,'quizzes',`${Styles.quiz_blue_icon}`,`${Styles.quiz_black_icon}`,'quizzes')}}
                        onMouseOut={(e) => {onMouseOut(e,'quizzes',`${Styles.quiz_blue_icon}`,`${Styles.quiz_black_icon}`,'quizzes')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'quizzes'} className={`sprite_image_small_2 ${activeButton.includes('quizzes') ? `${Styles.quiz_blue_icon}` : `${Styles.quiz_black_icon}`} mr-2 my-auto`}></span></div>Quizzes
                        </div>
                      </Link>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card className={` ${activeKey === '2' ? 'bg-white' : Styles.card_border}`} style={{borderTop: '1px solid #ebe8e8', borderBottom: '1px solid #ebe8e8'}}>
                  <Link to="/about-us" >
                    <Accordion.Toggle as={Card.Header} eventKey="2" className={`${Styles.border_bg_none} ${Styles.left_nav_link_header} pl-4`} onClick={ () => {setActiveKey(activeKey === '2' ? '' : '2')}} >
                      <div className={`${activeKey === '2' ? Styles.left_nav_link_header_active : Styles.left_nav_link_header} d-inline-flex`} >
                        <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '2' ? `${Styles.lp_icon_white}` : `${Styles.lp_icon_black}`} mr-2 my-auto`}></span></div>
                        About Us
                        <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '2' ? 'down_white_arrow' : 'down_black_arrow rotate-right'} ml-2 my-auto`}></span></div>
                      </div>
                    </Accordion.Toggle>
                  </Link>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body className={`d-grid ${Styles.border_bg_none} py-2 pr-0 pl-2 ml-3`} >
                      <Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('our-team');}}
                        onMouseOver={(e) => {onMouseOver(e,'about_us',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'our-team')}}
                        onMouseOut={(e) => {onMouseOut(e,'about_us',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'our-team')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'about_us'} className={`sprite_image_small_2 ${activeButton.includes('our-team') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our team
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('why-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/why-us" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('why-us');}}
                        onMouseOver={(e) => {onMouseOver(e,'why_us',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'why-us')}}
                        onMouseOut={(e) => {onMouseOut(e,'why_us',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'why-us')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'why_us'} className={`sprite_image_small_2 ${activeButton.includes('why-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Why Us
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('ourtrainers') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/ourtrainers" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('ourtrainers');}}
                        onMouseOver={(e) => {onMouseOver(e,'ourtrainers',`${Styles.training_icon_blue}`,`${Styles.training_icon_black}`,'ourtrainers')}}
                        onMouseOut={(e) => {onMouseOut(e,'ourtrainers',`${Styles.training_icon_blue}`,`${Styles.training_icon_black}`,'ourtrainers')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'ourtrainers'} className={`sprite_image_small_2 ${activeButton.includes('ourtrainers') ? `${Styles.training_icon_blue}` : `${Styles.training_icon_black}`} mr-2 my-auto`}></span></div>Our Trainers
                        </div>
                      </Link>
                      <Link className={` ${activeButton.includes('our-presence') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/our-presence" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('our-presence');}}
                        onMouseOver={(e) => {onMouseOver(e,'our_presence',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'our-presence')}}
                        onMouseOut={(e) => {onMouseOut(e,'our_presence',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'our-presence')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'our_presence'} className={`sprite_image_small_2 ${activeButton.includes('our-presence') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our Presence
                        </div>
                      </Link>
                      {//<Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us/" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('about-us');}}
                        //   onMouseOver={(e) => {onMouseOver(e,'our_products',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                        //   onMouseOut={(e) => {onMouseOut(e,'our_products',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                        //   onFocus={ () => void 0 }
                        //   onBlur={ () => void 0 } >
                        //   <div className="d-flex font-w500" >
                        //     <div className={`d-flex`}><span id={'our_products'} className={`${activeButton.includes('about-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Our Products
                        //   </div>
                        // </Link>
                      }
                      <Link className={` ${activeButton.includes('leanpitch-reviews') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/leanpitch-reviews" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('leanpitch-reviews');}}
                        onMouseOver={(e) => {onMouseOver(e,'leanpitch-reviews',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'leanpitch-reviews')}}
                        onMouseOut={(e) => {onMouseOut(e,'leanpitch-reviews',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'leanpitch-reviews')}}
                        onFocus={ () => void 0 }
                        onBlur={ () => void 0 } >
                        <div className="d-flex font-w500" >
                          <div className={`d-flex`}><span id={'leanpitch-reviews'} className={`sprite_image_small_2 ${activeButton.includes('leanpitch-reviews') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>Testimonials
                        </div>
                      </Link>
                      {// <Link className={` ${activeButton.includes('about-us') ? Styles.left_nav_link_active : Styles.left_nav_link} `} to="/about-us/" activeClassName={`${Styles.left_nav_link_active}`} onClick={ () => {setActiveButton('about-us');}}
                      //   onMouseOver={(e) => {onMouseOver(e,'lp_tv',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                      //   onMouseOut={(e) => {onMouseOut(e,'lp_tv',`${Styles.play_blue_icon}`,`${Styles.play_black_icon}`,'about-us')}}
                      //   onFocus={ () => void 0 }
                      //   onBlur={ () => void 0 } >
                      //   <div className={`d-flex font-w500`} >
                      //     <div className={`d-flex`}><span id={'lp_tv'} className={`${activeButton.includes('about-us') ? `${Styles.play_blue_icon}` : `${Styles.play_black_icon}`} mr-2 my-auto`}></span></div>LP TV
                      //   </div>
                      // </Link>
                      }
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                {showPrimeCard()}
                {showSignout()}
                <div className="pb-4" style={{display: 'inline-block',backgroundImage: `url(${background_image.props.src})`, backgroundRepeat: 'no-repeat', backgroundSize: '100%', objectFit: 'cover'}}>
                  <div className="d-flex font-w500 float-left w-100 pl-4 pt-1">
                    <div className={`d-flex`}><span className={`sprite_image_2 ${Styles.phone_icon_black} mr-2 my-auto`}></span></div>
                    Contact Us
                  </div>
                  <div className="float-left w-100 d-grid justify-center" style={{fontSize: '13px'}}>
                    <a className={`text-black`} href="tel:+919606796005">+91-9606796005</a>
                    <a className={`text-black`} href="tel:+917358062677">+91-7358062677</a>
                  </div>
                  <div className="d-flex font-w500 float-left w-100 pl-4 pt-1">
                    <FontAwesomeIcon className='mr-2 my-auto' icon={faEnvelope} style={{color: 'rgb(128 128 128)', fontSize: '18px'}}/>Mail Us
                  </div>
                  <div className="float-left w-100 d-grid justify-center mb-2" style={{fontSize: '13px'}}>
                    <a className={`text-black`} href="mailto:info@leanpitch.com?Subject=Agile and Scrum Training" target="_blank" rel="noreferrer noopener">info@leanpitch.com</a>
                  </div>
                </div>
                <Card className={``} style={{borderRadius: '0', position: 'fixed', bottom: '0', width: '240px'}}>
                  <Accordion.Toggle as={Card.Header} eventKey="3" className={`${brand_icon_display === true ? '' : 'd-none'} ${Styles.border_bg_none} ${Styles.left_nav_link_header} pt-2 pb-1 ${Styles.layout_brand}`} style={{position: 'relative'}} onClick={(e) => {followBrandIcon(e);setActiveKey(activeKey === '3' ? '' : '3');}}>
                    <div className={`d-inline-flex`}>
                      {displayBrandIcon('collapse')}
                      <div className={`d-flex`} style={{position: 'absolute', right: '0'}}><span className={`sprite_image_2 down_white_arrow rotate-right ml-2 my-auto`}></span></div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body className={`d-grid ${Styles.border_bg_none} p-0 mx-0`} >
                      {displayBrandIcon('expand')}
                      <div className="pointer text-white text-center py-1" style={{backgroundColor: 'rgb(30, 64, 80)', fontSize: '1.2vw'}} onClick={(e) => {followBrandIcon(e);setActiveKey(activeKey === '3' ? '' : '3')}}>Done</div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                {/*<Card className={` ${activeKey === '3' ? 'bg-white' : Styles.card_border} pb-2`} style={{borderTop: '1px solid #ebe8e8'}}>
                  <Accordion.Toggle as={Card.Header} eventKey="3" className={` ${Styles.border_bg_none} ${Styles.left_nav_link_header} pl-4 pb-2`} onClick={ () => {setActiveKey(activeKey === '3' ? '' : '3');}} >
                    <div className="d-flex font-w500" >
                      <div className={`d-flex`}><span className={`sprite_image_2 ${Styles.phone_icon_black} mr-2 my-auto`}></span></div>
                      Contact Us
                      <div className={`d-flex`}><span className={`sprite_image_2 ${activeKey === '3' ? 'down_black_arrow' : 'down_black_arrow rotate-right'} ml-2 my-auto`}></span></div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body className={`d-grid ${Styles.border_bg_none} py-0 pr-0 pl-2 ml-3`} style={{ fontSize: `13px` }} >
                      <a className={`text-black pb-2`} href="tel:+919606796005">+919606796005</a>
                      <a className={`text-black pb-2`} href="tel:+917358062677">+917358062677</a>
                      <a className={`text-black`} href="mailto:info@leanpitch.com?Subject=Agile and Scrum Training" target="_blank" rel="noreferrer noopener">info@leanpitch.com</a>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>*/}
              </Accordion>
            </Col>
          </Col>
        </div>
      );
    }
  }
  const showPrimeCard = _ => {
    if (localSt_license !== 'Prime') {
      return (
        <Link className={`float-left w-100`}  to="/licenses" style={{background: 'linear-gradient(270deg, rgba(205, 65, 62, 1) 0%, rgba(184, 171, 12, 1) 100%)'}} >
          <Col className={`pl-4`}>
            <Accordion.Toggle as={Card.Header} eventKey="3" className={` ${Styles.border_bg_none} py-2 px-0`} >
              <div className="d-flex font-w500 text-white align-items-center" >
                Subscribe to Prime
                <img src={ForwardDotted} alt="forward_dotted_prime_subscription" className="ml-2" width="20" height="20" />
              </div>
            </Accordion.Toggle>
          </Col>
        </Link>
      )
    } else {
      return null
    }
  }

  return(
    <React.Fragment>
      {/*<Helmet>
        <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>
      </Helmet>*/}
      <Header/>
      <Col xs="12" sm="12" md="12" lg="12" className={`${Styles.layout_main_div} px-0`} style={{marginTop: '60px' }}>
        <CallBackModal selectedCity={"Online"} user={UserName}  type='online_course_contact' course_url={isBrowser() ? window.location.href : ''} submitted_from={isBrowser() ? window.location.href : ''}/>
        {displaySidebar()}
        <div id="child-layout" style={{width: '100%'}} className={`child-layout open unselectable`} onContextMenu={(e)=>{e.preventDefault();return false;}} >
          {children}
        </div>
        {/*<div className="d-flex" style={{position: `fixed`, bottom: `5px`, left: `240px`, width: `calc(100% - 240px)`, minWidth: `calc(100% - 240px)`, maxWidth: `calc(100% - 240px)` }}>
          <CookieConsent sameSite="strict" buttonStyle={{fontSize: `16px !important`, backgroundColor: `white`, border: `1px solid white`, borderRadius: `20px`, margin: `0px 15px 0px 0px`, padding: `0 16px` }} contentStyle={{margin: `8px`}} buttonWrapperClasses="my-auto" buttonText="Accept" style={{width: `434px`, position: `relative`, borderRadius: `30px`, margin: `0px 10px 5px 0px`}}>
            <p style={{fontSize: `12px`, lineHeight: `15px`, padding: `0 0 0 10px` }}>This website uses cookies to improve your experience.  See our <a className="blue-color" style={{color: `white`, borderBottom: `1px solid`}} href='/terms-and-conditions/'> terms and conditions </a>  to learn more.</p>
          </CookieConsent>
        </div>*/}
        <CookieConsent sameSite="strict" buttonStyle={{fontSize: `16px !important`, backgroundColor: `white`, border: `1px solid white`, borderRadius: `20px`, margin: `0px 15px 0px 0px`, padding: `0 16px` }} contentStyle={{margin: `8px`}} buttonWrapperClasses="my-auto" buttonText="Accept" style={{width: `434px`, right: 0, left: `unset`, borderRadius: `30px`, margin: `0px 10px 42px 0px`}}>
          <p style={{fontSize: `12px`, lineHeight: `15px`, padding: `0 0 0 10px` }}>This website uses cookies to improve your experience.  See our <a className="blue-color" style={{color: `white`, borderBottom: `1px solid`}} href='/terms-and-conditions/'> terms and conditions </a>  to learn more.</p>
        </CookieConsent>
      </Col>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
      <FireworkComponent time={timeLeft}/>
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
